import { render, staticRenderFns } from "./TotalChaosSupport.vue?vue&type=template&id=e0b048dc&"
import script from "./TotalChaosSupport.vue?vue&type=script&lang=js&"
export * from "./TotalChaosSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports